import { NgModule, Injector } from "@angular/core";
import { AdministrationComponent } from './administration.component';
import { MaterialModule } from '.././shared/material.module';
import { DrivingScheduleComponent } from "./driving-schedule/driving-schedule.component";
import { BfsMapsComponent } from "./bfsmap/bfs-maps.component";
import { AgGridModule } from 'ag-grid-angular';
import { BtnDownloadCellRenderer } from "./button-download-cell-renderer.component"
import { BtnDeleteCellRenderer } from "./button-delete-cell-renderer.component"
import { CommonModule } from '@angular/common';
import { ServiceLocator} from "../services/service.locator"
import { MatDialog } from '@angular/material/dialog';
import { TransferPointsComponent } from './transfer-points/transfer-points.component';
import { StartupService } from "../services/startup.service";
import { ManageBusComponent } from './busses/manage-bus/manage-bus.component';
import { ReactiveFormsModule } from "@angular/forms";
import { BussesComponent } from "./busses/busses.component";
import { BusService } from "../services/bus.service";
import { ToastrService } from "ngx-toastr";
import { DriverScheduleService } from "../services/driverschedule.service";
import { BfsService } from "../services/bfs.service";

@NgModule({
  imports: [
    ReactiveFormsModule,
    MaterialModule,
    CommonModule,
    AgGridModule,
    
    
  ],
  declarations: [
    AdministrationComponent,
    DrivingScheduleComponent,
    BfsMapsComponent, 
    BtnDownloadCellRenderer,
    BtnDeleteCellRenderer,
    TransferPointsComponent,
    BussesComponent,
    ManageBusComponent   

  ],
  exports: [],
  providers: []
})
export class AdministrationModule {
  constructor(
    public dialog: MatDialog,
    public startupService: StartupService,
    public busService: BusService,
    public toastr: ToastrService,
    public driverScheduleService: DriverScheduleService,
    public bfsService: BfsService) {
    ServiceLocator.injector = Injector.create(
      { providers: [
        { provide: MatDialog, deps: [] },
        { provide: StartupService, deps: [] },
        { provide: BusService, deps: [] },
        { provide: ToastrService, deps: [] },
        { provide: DriverScheduleService, deps: [] },
        { provide: BfsService, deps: [] },
        ]
      });
    ServiceLocator.dialog = dialog;
    ServiceLocator.driverScheduleService = driverScheduleService;
    ServiceLocator.bfsService = bfsService;
    ServiceLocator.busService = busService;
    ServiceLocator.toastr = toastr;
  }
}
